export const cookies = {
  HUBSPOT: 'hubspotutk',
  MESSAGES: 'messagesUtk',
  IS_OPEN: 'hs-messages-is-open',
  HIDE_WELCOME_MESSAGE: 'hs-messages-hide-welcome-message',
  WIDGET_POSITION: 'hs-messages-widget-position',
  WIDGET_SIZE: 'hs-messages-widget-size',
  HUBSPOT_API_CSRF: 'hubspotapi-csrf',
  HSTC: '__hstc',
  HSSC: '__hssc',
  GLOBAL_COOKIE_OPT_OUT: '__hs_opt_out'
};
export const cookieValues = {
  GLOBAL_COOKIE_OPT_OUT_YES: 'yes',
  GLOBAL_COOKIE_OPT_OUT_NO: 'no'
};